import { Component } from 'react';

const withLoading =
  ({ loadingClassName }) =>
  WrappedComponent => {
    class ComponentWithLoading extends Component {
      state = {
        isLoaded: false
      };

      handleLoad = () => {
        this.setState({
          isLoaded: true
        });
      };

      render() {
        return (
          <WrappedComponent
            {...this.props}
            isLoaded={this.state.isLoaded}
            handleLoad={this.handleLoad}
            loadingClassName={!this.state.isLoaded ? loadingClassName : ''}
          />
        );
      }
    }
    return ComponentWithLoading;
  };

export default withLoading;
